import config from '../../config'
import fetch from '../../lib/wrappedFetch'

class PollQuestionService {
  fetchActiveQuestionsForUser = params => {
    return fetch(config.config.endpointUrls.fetchActiveQuestionsForUser(params), {
      method: 'GET'
    })
  }

  fetchPollQuestionInstances = params => {
    return fetch(config.config.endpointUrls.fetchPollQuestionInstances(params), {
      method: 'GET'
    })
  }

  deletePollQuestionInstanceById = params => {
    return fetch(config.config.endpointUrls.deletePollQuestionInstanceById(params), {
      method: 'DELETE'
    })
  }

  savePollQuestionAnswers = params => {
    return fetch(config.config.endpointUrls.savePollQuestionAnswers(), {
      method: 'POST',
      body: {
        ...params
      }
    })
  }
}

export default new PollQuestionService()



// WEBPACK FOOTER //
// ../src/services/pollQuestionService/pollQuestionService.js